export * from './localStorage';
export * from './sessionStorage';
export * from './webStorage';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ngx-webstorage/dist/decorators/index.js
// module id = ../../../../ngx-webstorage/dist/decorators/index.js
// module chunks = 18